import {
  HomeIcon,
  ArrowTrendingUpIcon,
  ClipboardDocumentListIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import { NavLink, useLocation } from "react-router-dom";

const MainNavigation = () => {
  const location = useLocation();
  let parentPath = location.pathname.split("/")[1];

  return (
    <nav className="bg-indigo-600 fixed bottom-0 w-full grid grid-flow-col grid-cols-4 ">
      <NavItem
        link={"/"}
        iconType={"workouts"}
        label={"Workout Logs"}
        isActive={["workout", "", "create-workout", "edit-workout"].includes(
          parentPath,
        )}
      />
      <NavItem
        link={"progress"}
        iconType={"progress"}
        label={"Progress"}
        isActive={["progress"].includes(parentPath)}
      />
      <NavItem
        link={"programs"}
        iconType={"programs"}
        label={"Programs"}
        isActive={["programs"].includes(parentPath)}
      />
      <NavItem
        link={"account"}
        iconType={"account"}
        label={"Account"}
        isActive={["account", "admin-dashboard"].includes(parentPath)}
      />
    </nav>
  );
};

const iconComponents = {
  workouts: HomeIcon,
  progress: ArrowTrendingUpIcon,
  programs: ClipboardDocumentListIcon,
  account: UserCircleIcon,
};

const NavItem = (props) => {
  const Icon = iconComponents[props.iconType];
  return (
    <NavLink
      to={props.link}
      className={`main-nav-link flex flex-col items-center py-3 ${
        props.isActive ? "bg-indigo-900" : ""
      }`}
    >
      <Icon className="h-6 w-6 text-white" aria-hidden="true" />
      <p className="text-white text-[10px] text-center">{props.label}</p>
    </NavLink>
  );
};

export default MainNavigation;
